export default __webpack_public_path__ + "418f2f6f693005736ca30cd82c85d947.svg";